<nav aria-label="breadcrumb" class="p-3">
    <ol class="breadcrumb custom-breadcrumb">
        <li class="breadcrumb-item">
            <a [routerLink]="'/home'" class="text-decoration-none">Home</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            {{ isCreateMode ? 'Create Group' : enterpriseName }}
        </li>
    </ol>
</nav>
<div class="container-fluid">
    <div class="row">
        <div class="col-2">
            <ul class="nav flex-column nav-tabs" role="tablist">
                <li class="nav-item nav-tab">
                    <a class="nav-link py-3"
                       [routerLink]="isCreateMode ? '/group-management/create' : ['/group-management', enterpriseId, 'details']"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Group Name & Instances
                    </a>
                </li>
                <li class="nav-item" *ngIf="!isCreateMode">
                    <a class="nav-link py-3"
                       [routerLink]="isCreateMode ? '/group-management/administrators' : ['/group-management', enterpriseId, 'administrators']"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Accounts
                    </a>
                </li>
                <li class="nav-item" *ngIf="!isCreateMode">
                    <a class="nav-link py-3"
                       [routerLink]="isCreateMode ? '/group-management/administrators' : ['/group-management', enterpriseId, 'single-sign-on']"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Single Sign-on
                    </a>
                </li>
                <li class="nav-item" *ngIf="!isCreateMode && (isRcmAiPlatformEnabled || hasAccessAreas)">
                    <a class="nav-link py-3"
                       [routerLink]="['/group-management', enterpriseId, 'applications']"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Applications
                    </a>
                </li>
	            <li class="nav-item" *ngIf="!isCreateMode && isDevtoolEnabled">
		            <a class="nav-link py-3"
		               [routerLink]="isCreateMode ? '/group-management/administrators' : ['/group-management', enterpriseId, 'upload-csv']"
		               routerLinkActive="active-link"
		               [routerLinkActiveOptions]="{ exact: true }">
			            Upload CSV
		            </a>
                </li>
                <li class="nav-item" *ngIf="!isCreateMode">
                    <a class="nav-link py-3"
                       [routerLink]="isCreateMode ? '/group-management/administrators' : ['/group-management', enterpriseId, 'settings']"
                       routerLinkActive="active-link"
                       [routerLinkActiveOptions]="{ exact: true }">
                        Settings
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-10">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
